<template>
    <div class="whatsapp-wrapper">
        <div class="whatsapp-popup" v-if="showPopup">
            <button class="popup-close" @click="closePopup">
                <i class="fas fa-times"></i>
            </button>
            
            <div class="popup-header">
                <div class="popup-icon">
                    <i class="fab fa-whatsapp"></i>
                </div>
                <h3>{{ config.wa_popup_title || 'Inicia una Conversación' }}</h3>
                <div v-html="config.wa_popup_description || 'Hola, elige uno de nuestros representantes para comunicarte vía WhatsApp.'"></div>
            </div>
            
            <div class="popup-body">
                <p class="notice">{{ config.wa_popup_notice || 'Estamos aquí para asistirte:' }}</p>
                
                <div class="agents-list">
                    <a 
                        v-for="agent in whatsappAgents" 
                        :key="agent.id"
                        :href="`https://wa.me/${cleanPhoneNumber(agent.numero)}?text=${encodeURIComponent(agent.welcome_message || 'Hola')}`"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="agent-item"
                        @click="closePopup"
                    >
                        <div class="agent-avatar">
                            <img 
                                v-if="agent.avatar" 
                                :src="`/storage/${agent.avatar}`" 
                                :alt="agent.nombre"
                            >
                            <i v-else class="fas fa-user"></i>
                        </div>
                        <div class="agent-info">
                            <div class="agent-name">{{ agent.nombre }}</div>
                            <div class="agent-role">{{ agent.cargo || 'Soporte' }}</div>
                        </div>
                        <div class="agent-status">
                            <span class="status-dot active"></span>
                            En línea
                        </div>
                    </a>
                </div>
            </div>
        </div>
        
        <!-- WhatsApp Float Button -->
        <button class="whatsapp-float-btn" @click="togglePopup" v-if="!showPopup">
            <i class="fab fa-whatsapp"></i>
        </button>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'WhatsAppPopup',
    data() {
        return {
            showPopup: false
        };
    },
    computed: {
        ...mapState(['config']),
        ...mapGetters(['whatsappAgents'])
    },
    methods: {
        togglePopup() {
            this.showPopup = !this.showPopup;
        },
        closePopup() {
            this.showPopup = false;
        },
        cleanPhoneNumber(phone) {
            if (!phone) return '';
            return String(phone).replace(/\D/g, '');
        }
    }
};
</script>

<style scoped>
.whatsapp-wrapper {
    /* Wrapper transparente que no afecta el posicionamiento */
    position: relative;
    pointer-events: none;
}

.whatsapp-wrapper > * {
    pointer-events: auto;
}

.whatsapp-popup {
    position: fixed;
    bottom: 100px;
    right: 30px;
    width: 350px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 15px 60px rgba(0, 0, 0, 0.15);
    z-index: 999;
    animation: slideUp 0.3s ease;
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.popup-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.1);
    border: none;
    color: #666;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.popup-close:hover {
    background: rgba(0, 0, 0, 0.15);
    color: #333;
}

.popup-header {
    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
    color: #fff;
    padding: 2rem;
    border-radius: 16px 16px 0 0;
    text-align: center;
}

.popup-icon {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
}

.popup-icon i {
    font-size: 2rem;
}

.popup-header h3 {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.popup-body {
    padding: 1.5rem;
}

.notice {
    color: #64748b;
    font-size: 0.875rem;
    margin-bottom: 1rem;
}

.agents-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.agent-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 12px;
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
}

.agent-item:hover {
    background: #e0f2fe;
    transform: translateX(5px);
}

.agent-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: #25D366;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.agent-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.agent-info {
    flex: 1;
}

.agent-name {
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.25rem;
}

.agent-role {
    font-size: 0.875rem;
    color: #64748b;
}

.agent-status {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #25D366;
    font-weight: 500;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #25D366;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

.whatsapp-float-btn {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
    color: #fff;
    border: none;
    box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    z-index: 998;
    transition: all 0.3s ease;
    animation: float 3s ease-in-out infinite;
}

@keyframes float {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
}

.whatsapp-float-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 10px 35px rgba(37, 211, 102, 0.5);
}

@media (max-width: 576px) {
    .whatsapp-popup {
        width: calc(100% - 2rem);
        right: 1rem;
        bottom: 90px;
    }
    
    .whatsapp-float-btn {
        width: 55px;
        height: 55px;
        bottom: 20px;
        right: 20px;
        font-size: 1.75rem;
    }
}
</style>
